import React from 'react';
import styled from 'styled-components';
import close_icon from '../../images/close_icon.png'
import {useHistory} from 'react-router-dom'

export default function ChangePageTop(props) {
    const history = useHistory();

    return (
        <TopInner style={{borderBottom:props.borderbottom}}>
            <Title>{props.title}</Title>
            <Back onClick={()=>{history.goBack()}} >
                <img src={close_icon}></img>
            </Back>
        </TopInner>
    );
}






const TopInner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 200;
    width: 100%;
    height: calc(100vw*(51/375));
    display: felx;
    align-items: center;
    padding:0 calc(100vw*(17/375));

`
const Title = styled.h1`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    // margin-left: calc(100vw*(131.2/375));
`

const Back = styled.a`
    display:block;
    width: calc(100vw*(14/375));
    height: calc(100vw*(14/375));
    margin-left: calc(100vw*(-11/375));
`
